const latRad = (lat) => {
  const sin = Math.sin((lat * Math.PI) / 180)
  const radX2 = Math.log((1 + sin) / (1 - sin)) / 2
  return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2
}

const zoom = (mapPx, fraction) => {
  return Math.floor(Math.log((mapPx - 20) / 256 / fraction) / Math.LN2)
}

export const calculateZoomLevel = (bounds, width, height) => {
  /**
   * Better zoom level calculation.
   * This function produces a tighter zoom when compared to map.fitBounds
   */
  const ne = bounds.getNorthEast()
  const sw = bounds.getSouthWest()

  const latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI

  const lngDiff = ne.lng() - sw.lng()
  const lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360

  const latZoom = zoom(height * 1.33, latFraction)
  const lngZoom = zoom(width * 1.25, lngFraction)

  const zoomLevel = Math.min(latZoom, lngZoom)

  return isNaN(zoomLevel) ? 3 : zoomLevel
}
